<div class="container-fluid">
  <div *ngIf="loading; else loaded">
    <app-loading></app-loading>
  </div>

  <ng-template #loaded>
    <app-statistics-book
      (result)="filter($event)"
    ></app-statistics-book>
    <!-- Page Heading -->
    <div class="page-heading mb-4">
      <h1 class="h3 mb-2 text-gray-800">
        <i class="fas fa-archive"></i> Tất cả sách lưu trữ
      </h1>
      <p class="mb-4">Mô-đun này hiển thị tất cả các sách lưu trữ và cho phép bạn quản lý chúng một cách hiệu quả.</p>
    </div>

    <!-- DataTales Example -->
    <div class="card mb-4">
      <div class="card-body">
        <div class="table-responsive">
          <app-arvived-book-list
            (idEvent)="edit($event)"
            (viewEvent)="view($event)"
            (deleteEvent)="delete($event)"
            [books]="books$"
          ></app-arvived-book-list>
          <app-modal-book [id]="id"></app-modal-book>
        </div>
      </div>
    </div>
  </ng-template>
</div>
